import { render, staticRenderFns } from "./LoadingMain.vue?vue&type=template&id=b6aa06ea&lang=html&"
import script from "./LoadingMain.vue?vue&type=script&lang=js&"
export * from "./LoadingMain.vue?vue&type=script&lang=js&"
import style0 from "./LoadingMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports